import { render } from "./GroupsView.vue?vue&type=template&id=46be6c58&scoped=true"
import script from "./GroupsView.vue?vue&type=script&lang=js"
export * from "./GroupsView.vue?vue&type=script&lang=js"

import "./GroupsView.vue?vue&type=style&index=0&id=46be6c58&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46be6c58"]])

export default __exports__